// Libraries
import { parseISO, getTime } from 'date-fns';

/**
 * Converts a string date to a UNIX timestamp.
 *
 * This function parses a string date in ISO 8601 format and returns its UNIX timestamp
 *
 * @param dateString - The string date to convert.
 * @returns The UNIX timestamp representing the input date.
 *
 * @remarks
 * This function uses the `date-fns` library to parse the input date string and convert
 * it to a UNIX timestamp.
 *
 */
export const stringDateToTime = (dateString: string) => getTime(parseISO(dateString));
